<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Web Banners</div>
            </div>
        </div>


            <div class="layout__padding-clear layout__width-75">
                <div class="component__columns-2 layout__margin-20-0">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/web-banner-720x500.png"
                         class="layout__width-90 layout__padding__bottom-25px">
                </div>
                <div class="component__columns-2 layout__margin-20-0">
                    <h3 class="text__colour-teal text__style-bold-900">Customised web banners branded to your
                        business.</h3>

                    <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                        Our web designers spend a lot of time online, and we know what works. We can design banners to
                        any size and specification – whether it’s for your own website, a partner site or those little
                        remarketing ads that follow you around the internet (you know the ones).
                    </div>

                    <div class="layout__padding-20-0">
                        <el-button class="layout__width-200px button-red"
                                   v-on:click="contactUs()">Find out more
                        </el-button>
                    </div>
                </div>
            </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                You may also like
            </div>

            <router-link class="link__colour-black" to="/products/digital/microsites">
                <div class="component__product-3">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/micrositemockup.jpg"
                         class="layout__width-100">
                    <div class="component__product__subtitles">
                        <div>Microsites</div>
                    </div>
                </div>
            </router-link>

            <router-link class="link__colour-black" to="/products/digital/social-media">
                <div class="component__product-3">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/socialmediamock.jpg"
                         class="layout__width-100">
                    <div class="component__product__subtitles">
                        <div>Social Media</div>
                    </div>
                </div>
            </router-link>

            <router-link class="link__colour-black" to="/products/digital/email-signature">
                <div class="component__product-3">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/email-sig-720x500.png"
                         class="layout__width-100">
                    <div class="component__product__subtitles">
                        <div>Email Signatures</div>
                    </div>
                </div>
            </router-link>
        </div>


    </div>

</template>

<script>

    import Router from '../../../router';

    export default {
        name: "WB",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            }
        }
    };
</script>